import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'

/**
 * Lumpsum rupee amounts — round to nearest rupee.
 *
 * Naming (lodash-style):
 * - showAsFormattedRupeeAmount → PlanAmount (.label = UI, .value = CTA)
 * - formatRupeeLabel    → string (display-only, never pass to CTA)
 * - roundToNearestRupee → number (rounding step only)
 */

export type PlanAmount = {
  value: number
  label: string
}

/** Raw API amount → rounded PlanAmount for lumpsum buy/sell. */
export function showAsFormattedRupeeAmount({ rawAmount }: { rawAmount: number }): PlanAmount {
  const value = roundToNearestRupee(rawAmount)
  return { value, label: formatRupeeLabelFromValue(value) }
}

/** Display-only. Use showAsFormattedRupeeAmount when the same amount is executed. */
export function formatRupeeLabel({ rawAmount }: { rawAmount: number }): string {
  return showAsFormattedRupeeAmount({ rawAmount }).label
}

/** Display-only. A negative raw amount is shown as "- ₹…". */
export function formatSignedRupeeLabel({ rawAmount }: { rawAmount: number }): string {
  const label = formatRupeeLabel({ rawAmount })
  if (rawAmount < 0) {
    return `- ${label}`
  }
  return label
}

export function roundToNearestRupee(rawAmount: number): number {
  if (!Number.isFinite(rawAmount)) {
    return 0
  }
  return Math.round(Math.abs(rawAmount))
}

function formatRupeeLabelFromValue(normalizedAmount: number): string {
  return String(roundOffAndFormatNumberWithCurrency(normalizedAmount))
}

export function formatPlanRupeeLabel(normalizedAmount: number): string {
  return formatRupeeLabelFromValue(normalizedAmount)
}
